import { inject, Pipe, PipeTransform } from '@angular/core';
import { DateHelperService } from '@services/date-helper/date-helper.service';

@Pipe({
  name: 'customDate',
  standalone: true
})
export class CustomDatePipe implements PipeTransform {

  private readonly dateHelper = inject(DateHelperService);

  transform(val: string | Date = '', ...args: unknown[]): number | string | boolean {
    switch (args[0]) {
      case 'format': {
        const addExtra: { day?: number; month?: number; year?: number; } = {};
        if (args?.[2]) addExtra[`${args?.[2]}`] = Number(args?.[3]) || 0;
        if (args?.[4]) addExtra[`${args?.[4]}`] = Number(args?.[5]) || 0;
        if (args?.[6]) addExtra[`${args?.[4]}`] = Number(args?.[7]) || 0;
        return this.dateHelper.formatDate(val, String(args?.[1]), addExtra);
      }

      case 'timeAgo': {
        return this.dateHelper.getTimeAgo(val);
      }

      case 'diffInSec': {
        return this.dateHelper.getRemainingTime('s', val, String(args?.[1] || ''), +args?.[2] || 0);
      }

      case 'diffInMins': {
        return this.dateHelper.getRemainingTime('m', val, String(args?.[1] || ''), +args?.[2] || 0);
      }

      case 'diffInHrs': {
        return this.dateHelper.getRemainingTime('H', val, String(args?.[1] || ''), +args?.[2] || 0);
      }

      case 'diffInDays': {
        return this.dateHelper.getRemainingTime('D', val, String(args?.[1] || ''), +args?.[2] || 0);
      }

      case 'diffInMonths': {
        return this.dateHelper.getRemainingTime('M', val, String(args?.[1] || ''), +args?.[2] || 0);
      }

      case 'remaingTime': {
        const inType: any = {}
        String(args?.[1] || 'D-H-m-s').split('-').forEach(item => inType[item] = true);
        let left = this.dateHelper.getRelativeTimeRemaining(val);
        if (inType?.Y && left?.Y === 0) inType.M = true;
        if (inType?.M && left?.M === 0) inType.D = true;
        if (inType?.D && left?.D === 0) inType.H = true;
        if (inType?.H && left?.H === 0) inType.m = true;
        if (inType?.m && left?.m === 0) inType.s = true;
        left = this.dateHelper.getRelativeTimeRemaining(val, inType);
        let retStr = '';
        if (inType?.Y) retStr = `${retStr} ${left.Y} ${left.Y === 1 ? 'Year' : 'Years'}`;
        if (inType?.M && left.M) retStr = `${retStr} ${left.M} ${left.M === 1 ? 'Month' : 'Months'}`;
        if (inType?.D && left.D) retStr = `${retStr} ${left.D} ${left.D === 1 ? 'Day' : 'Days'}`;
        if (inType?.H && left.H) retStr = `${retStr} ${left.H} ${left.H === 1 ? 'Hour' : 'Hours'}`;
        if (inType?.m && left.m) retStr = `${retStr} ${left.m} ${left.m === 1 ? 'Minute' : 'Minutes'}`;
        if (inType?.s && left.s) retStr = `${retStr} ${left.s} ${left.s === 1 ? 'Second' : 'Seconds'}`;
        retStr = retStr.split(' ').map((item:string, i: number) => {if (i!==2) item = item.toLowerCase(); return item}).join(' ');
        return retStr;
      }

      case 'isAfter': {
        const diff = this.dateHelper.getRemainingTime('ms', val, String(args?.[1] || ''));
        return diff > 0;
      }
    }
    return '';
  }

}
